<template>
  <div class="customer-select">
    <div
        class="cs-field"
        :class="{ 'cs-disabled': disabled }"
        @click="!disabled && openPicker()"
        @keydown.enter.prevent="!disabled && openPicker()"
        tabindex="0"
        role="button"
        aria-haspopup="dialog"
    >
      <div v-if="value" class="cs-value">
        <div class="cs-texts">
          <div class="cs-name">{{ customerName(value) }}</div>
          <div class="cs-mobile">{{ value.mobile_number || '—' }}</div>
        </div>
      </div>
      <div v-else class="cs-placeholder">
        {{ placeholder || label || 'انتخاب مشتری' }}
      </div>
      <div class="cs-icons">
        <button
            v-if="value && !disabled"
            class="cs-clear"
            @click.stop="clearSelection"
            :title="'پاک کردن'">×</button>
        <span class="cs-caret">▾</span>
      </div>
    </div>

    <div v-if="showPicker" class="cs-dialog-backdrop" @click.self="closePicker">
      <div class="cs-dialog" role="dialog" aria-modal="true">
        <div class="cs-dialog-header">
          <div class="cs-title">انتخاب مشتری</div>
          <button class="cs-close" @click="closePicker">×</button>
        </div>

        <div class="cs-filters">
          <input
              v-model="search"
              class="cs-input"
              type="text"
              placeholder="جستجو بر اساس نام یا شماره موبایل"
              @keyup.enter="applySearch"
              ref="searchInput"
          />
          <button class="cs-btn cs-btn-primary" @click="applySearch">جستجو</button>
        </div>

        <div class="cs-table-wrap">
          <table class="cs-table">
            <thead>
            <tr>
              <th>نام مشتری</th>
              <th style="width:160px;">شماره موبایل</th>
              <th style="width:100px;">انتخاب</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loadingList">
              <td colspan="3" class="cs-center">در حال بارگذاری...</td>
            </tr>
            <tr v-else-if="customersList.length === 0">
              <td colspan="3" class="cs-center cs-muted">مشتری‌ای یافت نشد</td>
            </tr>
            <tr
                v-for="c in customersList"
                :key="c.id"
                @dblclick="selectCustomer(c)"
                class="cs-row"
                :class="{ 'cs-row-selected': value && value.id === c.id }"
            >
              <td><div class="cs-name">{{ customerName(c) }}</div></td>
              <td class="cs-mobile">{{ c.mobile_number || '—' }}</td>
              <td><button class="cs-btn cs-btn-primary" @click="selectCustomer(c)">انتخاب</button></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="cs-pagination">
          <div class="cs-pageinfo mt-3 mr-2">
            نمایش {{ offset + 1 }} تا {{ Math.min(offset + limit, total) }} از {{ total }}
          </div>
          <div class="cs-pager mt-2 mr-3">
            <button class="cs-btn ml-2" :disabled="offset===0" @click="prevPage">قبلی</button>
            <button class="cs-btn" :disabled="offset + limit >= total" @click="nextPage">بعدی</button>
          </div>
        </div>

        <div class="cs-dialog-actions">
          <button class="cs-btn" @click="closePicker">بستن</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerSelect',
  model: { prop: 'value', event: 'input' },

  props: {
    value: { type: Object, default: null },
    label: { default: null },
    placeholder: { default: null },
    disabled: { default: false },
  },

  data() {
    return {
      showPicker: false,
      loadingList: false,
      customersList: [],
      total: 0,
      limit: 10,
      offset: 0,
      search: '',
    };
  },

  methods: {
    customerName(c) {
      const name = [c.first_name, c.last_name].filter(Boolean).join(' ').trim();
      return name || c.username || 'بدون نام';
    },

    fetchCustomersList() {
      this.loadingList = true;
      const params = { limit: this.limit, offset: this.offset };
      if (this.search) params.search = this.search;
      this.request({
        url: this.endpoint('shop/adminCustomerSearch'),
        method: 'get',
        params,
        success: (data) => {
          this.customersList = data.results || [];
          this.total = data.count || 0;
          this.loadingList = false;
        },
        error: () => { this.loadingList = false; }
      });
    },

    openPicker() {
      this.showPicker = true;
      this.offset = 0;
      this.fetchCustomersList();
      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus();
      });
    },
    closePicker() { this.showPicker = false; },
    applySearch() { this.offset = 0; this.fetchCustomersList(); },
    prevPage() { if (this.offset === 0) return; this.offset = Math.max(0, this.offset - this.limit); this.fetchCustomersList(); },
    nextPage() { if (this.offset + this.limit >= this.total) return; this.offset += this.limit; this.fetchCustomersList(); },

    selectCustomer(c) {
      this.showPicker = false;
      this.$emit('input', c);
      this.$emit('change', c);
    },

    clearSelection() {
      this.$emit('input', null);
      this.$emit('change', null);
    },
  },
};
</script>

<style scoped>
.cs-field {
  display:flex; align-items:center; justify-content:space-between;
  width:100%; min-height:40px; padding:8px 10px; border:1px solid #e5e7eb; border-radius:10px;
  background:#fff; cursor:pointer; outline:none;
}
.cs-field:focus { box-shadow:0 0 0 3px rgba(59,130,246,0.2); }
.cs-disabled { opacity:.6; cursor:not-allowed; }
.cs-value { display:flex; align-items:center; gap:8px; min-width:0; }
.cs-texts { min-width:0; }
.cs-name { font-size:12px; font-weight:600; color:#111827; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:280px; }
.cs-mobile { font-size:11px; color:#6b7280; margin-top:2px; }
.cs-placeholder { color:#9ca3af; font-size:12px; }
.cs-icons { display:flex; align-items:center; gap:6px; }
.cs-clear { border:none; background:#f3f4f6; border-radius:6px; padding:0 6px; cursor:pointer; }
.cs-caret { font-size:12px; color:#6b7280; }

.cs-dialog-backdrop {
  position:fixed; inset:0; background:rgba(0,0,0,.35);
  display:flex; align-items:center; justify-content:center; z-index:1000;
}
.cs-dialog {
  width: min(700px, 96vw);
  background:#fff; border-radius:12px; overflow:hidden; box-shadow:0 20px 60px rgba(0,0,0,.25);
  display:flex; flex-direction:column;
}
.cs-dialog-header {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 14px; border-bottom:1px solid #eee; background:#fafafa;
}
.cs-title { font-weight:700; }
.cs-close { border:none; background:transparent; font-size:20px; line-height:1; cursor:pointer; }

.cs-filters { display:flex; flex-wrap:wrap; gap:8px; padding:12px 14px; }
.cs-input {
  flex:1 1 260px; border:1px solid #e5e7eb; border-radius:8px; padding:8px 10px; min-width:220px;
}

.cs-btn { border:1px solid #e5e7eb; background:#fff; border-radius:8px; padding:8px 12px; cursor:pointer; }
.cs-btn-primary { background:#2563eb; color:#fff; border-color:#2563eb; }

.cs-table-wrap { overflow:auto; max-height:50vh; }
.cs-table { width:95%; border-collapse:collapse; margin: 0 auto; }
.cs-table th, .cs-table td { border-bottom:1px solid #f1f5f9; padding:10px; text-align:right; }
.cs-row { cursor:pointer; }
.cs-center { text-align:center; }
.cs-muted { color:#94a3b8; }

.cs-pagination {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafafa;
}
.cs-pageinfo { font-size:12px; color:#6b7280; }

.cs-dialog-actions { padding:10px 14px; display:flex; justify-content:flex-end; gap:8px; }
.cs-row-selected { background:#f0f7ff; }
</style>
